var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgNeedlervariant(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 120,
    height: 60,
    viewBox: "0 0 120 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M55.2813 56.766L62.8158 54.3074L64.1673 55.0679L65.2653 54.7304L63.8298 53.1255C63.8298 53.1255 63.4953 51.6209 64.2453 50.2484C64.9953 48.8744 66.2538 47.5154 66.2538 47.5154L70.4193 45.609L71.0943 45.9465L72.2583 45.1394L75.6558 43.9605H76.5423L77.7678 43.5074L83.0043 43.0244L84.2298 43.6215L85.4568 43.0859L86.7648 43.6635L88.0743 43.1144C88.0743 43.1144 88.9938 45.1665 90.0588 44.55C91.1238 43.9335 91.3683 43.2404 91.3683 43.2404L94.1553 41.7195L96.1983 43.023L97.9563 45.057L98.6748 45.564L99.6033 46.5359L97.9143 48.732L69.4683 57.1365C69.4683 57.1365 63.8583 58.386 62.3358 58.5375C60.8148 58.689 57.3033 58.7475 56.1573 58.5375C55.0128 58.3275 54.6738 57.5685 54.6738 57.5685L55.2813 56.7644V56.766Z",
    fill: "#FAFAFB"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M81.8309 13.6229C80.6339 12.3989 77.1539 12.1589 77.1539 12.1589L72.8924 11.9864L73.8629 11.3759L76.5419 9.34793L77.7674 7.77443L74.3534 9.34793L76.5419 6.25343L78.4529 3.94193V2.48543L75.2579 4.84643L70.7924 8.55443L66.1499 12.5114L62.9669 13.0229L67.3484 7.77443L68.1089 6.14843L69.4664 3.43493L69.2144 2.08493L62.9654 8.95793L60.8639 10.3664L58.4489 12.5144L57.5699 14.2484L54.9014 15.0104L57.1334 11.3804V10.4129L57.8294 8.11943L58.2374 6.50543L58.1114 4.15793L56.1569 6.08843L52.1984 11.9909L51.6074 13.4039L49.3634 16.5749L46.3964 18.1484L46.7924 16.5629L48.6509 14.9294L49.6649 13.1279L50.7449 9.35243H49.5449L48.9689 7.63043L45.6389 12.2819L44.7104 14.2529L42.7109 17.3429L41.4584 18.8309L40.1774 21.0119L36.4889 23.0654V23.9939L32.3084 24.2054L27.3674 26.9504L24.7154 27.9929L22.4684 31.5119L19.5119 32.8634L19.0889 33.5819L25.9304 33.3704L27.1559 31.8929L29.0564 31.7234L28.9724 33.9194L25.9319 34.5944C25.9319 34.5944 25.8479 36.2414 26.4809 36.7799C27.1139 37.3184 29.2259 37.2554 29.2259 37.2554L29.5634 39.7889L27.3674 39.4799L25.5929 37.9319L20.3564 37.8734L19.3424 38.4389L22.1294 40.1279L24.4949 44.0984L26.8604 44.6054L33.3644 48.4904L38.0729 51.5834L43.9664 53.8679L51.9479 56.5994L53.4689 54.7409L60.8684 52.4519L61.7759 51.6614C61.8884 49.9334 63.7379 45.5279 63.7379 45.5279C63.7379 45.5279 65.7089 39.3509 65.7464 38.4389C65.7839 37.5269 65.7179 36.4124 64.4504 36.0734C63.1829 35.7359 62.5214 34.6544 62.3384 33.5399C62.1554 32.4254 64.2494 31.2029 64.2494 31.2029L64.7879 30.0044L63.2669 27.6269L68.1119 25.9394L78.9779 26.0219L79.9199 23.6984L77.7704 22.9244L74.1524 22.0964L82.1024 19.7699C82.1024 19.7699 83.0309 18.4184 83.3669 17.0054C83.7029 15.5924 83.0309 14.8499 81.8339 13.6259L81.8309 13.6229ZM58.2374 44.1359L55.0274 45.1079C53.8019 44.8964 49.0304 42.4889 48.9029 41.9399C48.7754 41.3909 48.4379 39.7439 48.4379 39.7439H49.4519L49.7894 38.9414L50.3384 38.7299L50.4644 37.2524L49.9154 36.9989L50.0849 36.4919L50.8874 35.9849L50.8034 35.1824L49.9169 34.7174L49.9589 34.2899H50.6774V33.3659L50.0444 32.6909L49.4534 32.5214V31.2539C49.4534 31.2539 50.5094 30.7889 51.6074 30.6629C52.7054 30.5369 52.9589 30.8324 52.9589 30.8324L53.3384 34.7594L55.8299 35.5619L56.1674 36.8714L55.4069 38.2649C55.4069 38.2649 55.3229 38.9399 55.4069 39.1514C55.4909 39.3629 57.8144 40.0799 58.3214 40.2914C58.8284 40.5029 58.7009 40.7144 58.7864 41.4734C58.8704 42.2339 58.2374 44.1344 58.2374 44.1344V44.1359ZM58.1114 34.2899C57.2039 34.2899 56.4689 33.5549 56.4689 32.6474C56.4689 31.7399 57.2039 31.0049 58.1114 31.0049C59.0189 31.0049 59.7539 31.7399 59.7539 32.6474C59.7539 33.5549 59.0189 34.2899 58.1114 34.2899Z",
    fill: "#FAFAFB"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M29.5605 46.143C29.5605 46.143 29.5605 45.8385 30.912 45.1065C32.2635 44.3745 35.868 44.3175 36.8805 44.487C37.8945 44.6565 40.3725 46.5705 40.3725 46.5705",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M41.1853 27.942C41.1853 27.942 40.2463 28.5929 39.6538 28.6349C39.0613 28.6769 38.7253 28.431 38.6398 27.942C38.5543 27.453 39.1663 26.7299 39.1663 26.7299",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M42.3989 29.5515L41.6804 30C41.6804 30 41.1734 30.6915 41.6804 31.311C42.1874 31.9305 43.9604 31.0065 43.9604 31.0065",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M41.6823 31.311L39.7818 31.8885L39.5703 33.1125",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M37.3018 31.5239V29.3114L38.8363 28.3799",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M37.3018 39.2549V39.9299V42.4469L39.3583 43.6709",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M42.1453 42.8265C42.1453 42.8265 40.4983 42.2775 40.9198 41.052L38.8348 39.9285H37.3018",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M40.9209 41.0534C40.9209 41.0534 41.4279 40.2269 43.4124 41.4644",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M40.9214 45.4904C40.9214 45.4904 40.2059 44.7704 39.9089 44.5589C39.6119 44.3474 39.5294 44.2214 39.9089 43.6724C40.2884 43.1234 41.1854 44.1374 41.1854 44.1374",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M25.5898 41.8124C25.7158 41.9819 27.3643 42.1919 27.3643 42.1919",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M25.5898 28.6409L27.3643 28.3799",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M59.094 46.7969L59.4195 47.5139",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M59.2573 48.2325L58.4473 48.6555",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M60 48.2325L60.4335 48.8655",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M60 47.5139L60.864 46.7969",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M65.2644 54.7304C65.2644 54.7304 65.2224 52.7459 65.7714 51.3089C66.3204 49.8734 67.2489 48.9014 68.4324 48.5639C69.6144 48.2264 76.4574 46.4099 77.7654 46.1564C79.0749 45.9029 81.7314 45.6074 84.6264 45.8189C87.5214 46.0304 91.4499 46.3259 92.2089 46.1564C92.9679 45.9869 96.1944 43.0244 96.1944 43.0244",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M97.4056 45.5234C97.4056 45.5234 96.3076 46.7519 95.8846 47.1929C95.4616 47.6339 91.7461 48.8774 91.7461 48.8774L96.0361 49.2824",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M87.4398 46.02C87.4398 46.02 87.4398 48.3105 86.9748 49.2825C86.5098 50.2545 82.6668 52.0275 81.5268 52.4085C80.3868 52.788 73.2483 54.942 71.8548 55.323C70.4613 55.704 69.4668 57.1395 69.4668 57.1395",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M71.094 45.9465L71.55 47.724",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M76.5417 43.9604L77.7657 46.1579",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M84.1439 43.9604L83.0039 45.5234",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M86.7631 43.665L85.4551 45.8805",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M67.9514 23.5259C67.9514 23.6519 68.2664 25.4264 68.2664 25.4264",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M70.6621 22.1745C70.6621 22.1745 70.9921 24.897 70.9081 25.4265",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M72.8922 22.3425L72.6807 25.638",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M58.4473 24.4755L59.4193 25.638",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M60 23.8004L60.864 25.0559",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M61.4189 23.1884L62.1224 24.2009",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M48.4374 39.1664L49.1274 38.1389C49.1274 38.1389 47.2404 36.8579 47.2404 35.4494C47.2404 34.0409 48.6759 32.8589 48.6759 32.8589L48.6189 31.1984C48.6189 31.1984 46.0284 32.8319 46.0569 35.1824C46.0854 37.5329 48.4359 39.1664 48.4359 39.1664H48.4374Z",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M48.6493 35.499C48.8241 35.499 48.9658 35.3573 48.9658 35.1825C48.9658 35.0077 48.8241 34.866 48.6493 34.866C48.4745 34.866 48.3328 35.0077 48.3328 35.1825C48.3328 35.3573 48.4745 35.499 48.6493 35.499Z",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M37.3018 24.8354C37.3018 24.8354 40.4563 25.0529 40.6243 25.0574C40.7923 25.0619 42.1453 26.1584 42.1453 26.1584L41.8918 27.9884",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M53.376 25.638L53.7465 23.694L55.548 22.92L57.828 24.075",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M37.7529 22.7519C37.7529 22.7519 38.1024 23.0054 38.6319 23.1884C39.1614 23.3714 41.4549 23.6954 41.4549 23.6954L43.2429 25.9904L42.9609 27.4829L43.8054 28.1864H47.1279L51.0129 25.4264L51.2544 23.8004L55.7994 21.6824L57.2994 22.1744L70.1589 18.3029L75.7899 18.7259L78.6624 17.9939L79.6479 16.7264L83.3619 16.0004",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M66.4168 19.2599C66.4168 19.2599 65.4883 18.7244 65.4883 18.1049C65.4883 17.4854 65.4043 15.4859 65.4883 14.8109C65.5723 14.1359 66.1498 12.5099 66.1498 12.5099",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M56.1674 21.4005C56.1674 21.4005 56.0639 19.317 56.4674 18.6135C56.8709 17.91 58.1099 15.4875 58.1099 15.4875",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M45.1436 20.3999C45.2696 20.3999 51.1826 17.2739 51.9431 17.1479C52.7036 17.0219 53.9276 16.9784 53.9276 16.9784L55.2791 15.8849",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M70.1219 12.1064C87.2489 10.8659 83.0279 18.4154 83.0279 18.4154L82.0994 19.7669L73.3154 21.9629L76.2719 22.4219L79.9889 23.3144L79.7354 24.6659L78.9749 26.0174L67.8254 25.9334L63.2639 27.6224L64.7849 29.9999C64.7849 29.9999 64.8689 30.6629 64.0244 31.3394C63.1799 32.0144 62.2499 32.3534 62.3354 33.5354C62.4209 34.7174 62.5049 35.3939 64.4474 36.0689C66.3899 36.7439 65.7149 40.1234 65.2079 41.6444C64.7009 43.1654 63.2654 46.6274 62.6744 48.3179C62.0834 50.0069 61.6604 52.2029 61.6604 52.2029L53.4674 54.7364L51.9464 56.5949C51.9464 56.5949 42.0644 53.4689 37.9244 51.3584C33.7844 49.2479 33.3629 48.4859 33.3629 48.4859C33.3629 48.4859 31.5044 47.5574 29.3924 46.2899C27.2804 45.0224 26.8589 44.6009 26.8589 44.6009L24.4934 44.0939L22.1279 40.1234L19.5089 38.7719L19.0859 37.9274H26.0969L27.6179 39.7859H29.5604L29.2229 37.2524L26.9849 36.9989C26.9849 36.9989 25.9289 36.6194 25.8449 36.2384C25.7609 35.8589 25.5494 35.0564 25.9289 34.5914C26.3084 34.1264 28.9694 33.9164 28.9694 33.9164L29.0534 31.7204L27.1529 31.8899L25.9274 33.3674L19.0859 33.5789L19.5089 32.8604L22.4654 31.5089L24.9989 27.5384L27.3644 26.9474L32.6864 23.9909H36.4874V23.0624C36.4874 23.0624 38.7674 21.5459 43.4144 19.4204",
    stroke: "#FAFAFB",
    strokeWidth: 1.05,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M62.9658 13.0214C64.3038 12.7664 64.8678 12.6824 66.2523 12.5099",
    stroke: "#FAFAFB",
    strokeWidth: 1.05,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M46.3945 18.1423C49.8715 16.6453 52.84 15.4528 57.568 14.2438",
    stroke: "#FAFAFB",
    strokeWidth: 1.05,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M52.9575 30.8325C52.9575 30.8325 52.704 30.537 51.606 30.663C50.508 30.789 49.452 31.254 49.452 31.254V32.5215L50.043 32.691L50.676 33.366V34.29H49.9575L49.9155 34.7175L50.802 35.1825L50.886 35.9849L50.0835 36.492L49.914 36.999L50.463 37.2525L50.337 38.73L49.788 38.9414L49.4505 39.7439H48.4365C48.4365 39.7439 48.774 41.391 48.9015 41.94C49.029 42.489 53.8005 44.8965 55.026 45.108L58.236 44.1359C58.236 44.1359 58.869 42.2355 58.785 41.475C58.701 40.7145 58.827 40.5029 58.32 40.2929C57.813 40.0814 55.491 39.3644 55.4055 39.1529C55.32 38.9414 55.4055 38.2665 55.4055 38.2665L56.166 36.873L55.8285 35.5635L53.337 34.761L52.9575 30.8325V30.8325Z",
    stroke: "#FAFAFB",
    strokeWidth: 1.05,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M58.1103 34.2898C59.0174 34.2898 59.7528 33.5544 59.7528 32.6473C59.7528 31.7402 59.0174 31.0048 58.1103 31.0048C57.2031 31.0048 56.4678 31.7402 56.4678 32.6473C56.4678 33.5544 57.2031 34.2898 58.1103 34.2898Z",
    stroke: "#FAFAFB",
    strokeWidth: 1.05,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M54.5805 58.1939C54.5805 58.1939 54.411 56.8844 56.1435 56.3354C57.876 55.7864 62.817 54.3089 62.817 54.3089L64.1685 55.0694L65.2665 54.8999V54.3089L63.831 53.1269C63.831 53.1269 64.0005 50.4659 64.845 49.1144C65.6895 47.7629 66.3225 47.1299 66.3225 47.1299L70.419 45.6089L71.094 45.9464L71.517 45.3974L75.6555 43.9619H76.542L77.049 43.4549L83.3835 42.9059L84.228 43.6244L84.627 43.1174L85.875 43.0754L86.7615 43.6664L87.141 43.1174H88.0695C88.0695 43.1174 88.7025 44.8484 90.054 44.5529C91.4055 44.2574 91.3635 43.2434 91.3635 43.2434C91.3635 43.2434 92.589 42.9059 93.264 42.4829C93.939 42.0599 94.1505 41.7224 94.1505 41.7224C94.1505 41.7224 97.5285 43.4969 97.9515 45.0584L97.74 45.6914L98.6685 45.5654L99.597 46.5374L97.908 48.7334C97.908 48.7334 90.5175 50.8874 84.816 52.6184C79.1145 54.3494 70.4985 56.9264 68.3025 57.4334C66.1065 57.9404 58.818 59.6609 54.576 58.1939H54.5805Z",
    stroke: "#FAFAFB",
    strokeWidth: 1.05,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M58.2375 44.1359L63.4905 46.1429",
    stroke: "#FAFAFB",
    strokeWidth: 1.05,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M36.4863 23.9908C36.4863 23.9908 37.5558 25.6243 38.0628 26.0173C38.5698 26.4103 41.8353 28.3258 41.8353 28.3258L42.6243 29.5513L44.4828 31.3108L47.7483 30.6313C47.7483 30.6313 49.0998 28.7758 49.5498 28.3828C49.9998 27.9883 52.7598 26.2993 55.6308 25.0603C58.5033 23.8213 63.9093 21.9628 65.4858 21.7378C67.0623 21.5128 70.2723 21.4003 70.2723 21.4003L71.2293 21.9628H73.3128",
    stroke: "#FAFAFB",
    strokeWidth: 1.05,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M71.2309 21.9628C71.2309 21.9628 67.9654 23.1448 66.7264 23.8768C65.4874 24.6088 57.5479 29.5498 57.5479 29.5498C57.5479 29.5498 52.9309 30.0148 51.6064 30.6613",
    stroke: "#FAFAFB",
    strokeWidth: 1.05,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M60 33.1124L62.334 33.5354",
    stroke: "#FAFAFB",
    strokeWidth: 1.05,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M58.7943 34.1398L57.3018 39.9298",
    stroke: "#FAFAFB",
    strokeWidth: 1.05,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M58.1104 31.0065L57.5479 29.5515",
    stroke: "#FAFAFB",
    strokeWidth: 1.05,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M29.2228 37.251L38.9368 38.1375L40.9213 37.0335L44.2993 36.828C44.2993 36.828 45.3553 36.0255 45.5248 35.814C45.6943 35.6025 45.6508 35.0115 45.5248 34.8855C45.3988 34.7595 44.2573 34.29 44.2573 34.29L40.7518 34.14L39.1468 33.1125L28.9678 33.915",
    stroke: "#FAFAFB",
    strokeWidth: 1.05,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M29.0535 31.7189C29.0535 31.7189 33.8955 31.1699 37.302 31.7189L38.049 33.1124",
    stroke: "#FAFAFB",
    strokeWidth: 1.05,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M29.5605 39.7859C29.5605 39.7859 33.615 40.3274 35.0505 39.9299C36.486 39.5324 38.049 38.4344 38.049 38.4344",
    stroke: "#FAFAFB",
    strokeWidth: 1.05,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M46.7913 31.0065L44.2578 34.29",
    stroke: "#FAFAFB",
    strokeWidth: 1.05,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M33.3616 48.4859L35.6416 48.0914L37.3021 45.7829L40.3711 46.7969C40.3711 46.7969 40.7086 48.9374 42.1726 49.9499C43.6366 50.9639 53.4631 54.7364 53.4631 54.7364",
    stroke: "#FAFAFB",
    strokeWidth: 1.05,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M40.373 46.797L41.2175 45.783L40.7945 44.4315L41.2175 43.2495L42.9635 42.855L43.6385 40.9965L48.4386 40.377L44.3 36.8295",
    stroke: "#FAFAFB",
    strokeWidth: 1.05,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M40.1748 21.0073L41.6808 18.4423L42.3993 17.7943L43.9623 15.4858L44.7078 14.2468L45.6363 12.2758L47.1858 10.3048L47.8608 9.29085L50.2113 5.74335L48.0858 10.1923L50.2113 8.16585L47.5923 12.7828L51.2553 8.78535L49.6623 13.1218L48.3318 15.4873L46.7898 16.5568L45.1428 21.0073C45.1428 21.0073 45.4098 21.3718 43.9608 22.1743C42.5103 22.9768 41.6808 22.6948 41.6808 22.6948C41.6808 22.6948 41.4693 22.0198 41.6808 21.7378C41.8923 21.4558 43.4118 19.4203 43.4118 19.4203L47.5923 12.7843",
    stroke: "#FAFAFB",
    strokeWidth: 1.05,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M49.128 17.0024L49.944 15.4859L51.915 13.0079L52.197 11.9849L52.872 11.1494C52.872 11.1494 56.058 6.47544 56.154 6.08094C56.25 5.68644 57.1305 5.29194 57.1305 5.29194L60.2145 1.68744L57.2985 7.20594L59.7495 5.34744C59.7495 5.34744 56.9625 9.40194 56.4645 9.96444C55.9665 10.5269 54.588 12.5069 54.588 12.5069L59.091 8.78244L54.897 15.0014C54.897 15.0014 50.8515 16.3529 49.125 16.9994L49.128 17.0024Z",
    stroke: "#FAFAFB",
    strokeWidth: 1.05,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "M57.5686 14.2439L58.4476 12.7274L60.8626 10.3619L61.7701 9.85494L67.9501 3.20994L70.6606 0.78894L68.6956 4.05444L70.9201 2.25294L67.9501 6.36444L67.5706 7.51644L65.0371 10.4189L62.9656 13.0214L61.1671 14.9804L59.4196 15.8849C59.4196 15.8849 58.2796 15.3179 58.1101 15.2609C57.9406 15.2039 57.5686 14.2424 57.5686 14.2424V14.2439Z",
    stroke: "#FAFAFB",
    strokeWidth: 1.05,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    d: "M66.9508 11.9863C66.9508 11.9863 72.9193 6.64633 73.3138 6.30883C73.7083 5.97133 79.5298 1.69183 79.5298 1.69183L77.2513 4.73233L80.0713 2.87383L75.5668 7.71733L73.5118 9.49783L71.8513 10.6453L76.3003 8.33833L79.5313 6.83983C79.5313 6.83983 76.5103 9.63283 75.9553 10.0258C75.4003 10.4188 72.8938 11.9863 72.8938 11.9863L70.1233 12.1063L69.0358 13.4038C69.0358 13.4038 67.2343 14.1928 66.4168 13.6858C65.5993 13.1788 66.9523 11.9863 66.9523 11.9863H66.9508Z",
    stroke: "#FAFAFB",
    strokeWidth: 1.05,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    d: "M71.8501 10.644L70.1221 12.1065",
    stroke: "#FAFAFB",
    strokeWidth: 1.05,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNeedlervariant);
export default __webpack_public_path__ + "static/media/Needler variant.a0a1715954acb07091674f880ad0ab73.svg";
export { ForwardRef as ReactComponent };